import { render, staticRenderFns } from "./customer-profile.vue?vue&type=template&id=3e514760&"
import script from "./customer-profile.vue?vue&type=script&lang=js&"
export * from "./customer-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports